import { useState, useCallback, useRef } from 'react';

export interface Toast {
  id: string;
  message: string;
  actionLabel?: string;
  onAction?: () => void;
}

let toastCounter = 0;

export function useToast() {
  const [toast, setToast] = useState<Toast | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const dismiss = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast(null);
  }, []);

  const showToast = useCallback(
    (message: string, actionLabel?: string, onAction?: () => void) => {
      if (timerRef.current) clearTimeout(timerRef.current);
      const id = `toast-${++toastCounter}`;
      setToast({
        id,
        message,
        ...(actionLabel ? { actionLabel } : {}),
        ...(onAction ? { onAction } : {}),
      });
      timerRef.current = setTimeout(dismiss, 5000);
    },
    [dismiss],
  );

  const handleAction = useCallback(() => {
    if (toast?.onAction) {
      toast.onAction();
    }
    dismiss();
  }, [toast, dismiss]);

  return { toast, showToast, dismiss, handleAction };
}
